<template>
  <div class="sion-home-container">
  <div class="sino-panel" :style="{'paddingBottom':$route.path=='/new'?'19px':'49px'}">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <div class="home-footer">
      <template>
        <cube-tab-bar
          v-model="selectedLabelDefault"
          :data="tabs"
          @click="clickHandler"
          @change="changeHandler"
        ></cube-tab-bar>
      </template>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  data() {
    return {
      selectedLabelDefault: "最新",
      tabs: [
        {
          label: "最新",
          icon: "iconfenhui-gonghuihuodongbuxubaomingzhuanhuan- iconfont"
        },
        {
          label: "工会活动",
          icon: "iconfenhui-gonghuihuodongbuxubaomingzhuanhuan-5 iconfont"
        },
        {
          label: "节日慰问领取",
          icon: "iconfenhui-gonghuihuodongbuxubaomingzhuanhuan-2 iconfont"
        }
      ],
    };
  },
  created() {
    this.selectedLabelDefault = this.$route.query.label;
    this.clickHandler(this.$route.query.label);

    // 设置tab active
    let routeTitle=this.$route.meta.title;
    let hospitalName="";
    let hospitalInfoObj= localStorage.getItem("hospitalInfo");
    if(hospitalInfoObj&&hospitalInfoObj!='undefined') {
      let hospitalInfo= JSON.parse(hospitalInfoObj);
      hospitalName=hospitalInfo.hospitalName?hospitalInfo.hospitalName:'';
    } else {
      hospitalNamee=""
    }
    let data=[
      {meta:hospitalName||'天坛工会管理系统',label:"最新"},
      {meta:'我的活动',label:"工会活动"},
      {meta:'我的节日慰问',label:"节日慰问领取"},
    ];
    data.forEach(item => {
      if(routeTitle==item.meta){
        this.selectedLabelDefault=item.label
      } 
    })
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "login") {
      next({ name: "personalCenter" });
    } else {
      next(); // 注意：这边next必须要写
    }
  },
  methods: {
    clickHandler(label) {
      if (label == "节日慰问领取") {
        this.$router.replace("/welfare");
      } else if (label == "工会活动") {
        this.$router.replace("/activity");
      } else if (label == "最新") {
        this.$router.replace("/new");
      }
    },
    changeHandler() {

    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/index.styl';

.home-footer {
  height: 49px;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;

  .cube-tab {
    i {
      font-size: 22px;
    }
    div{
      font-size:12px;
    }
  }
}
</style>